module.exports = __webpack_public_path__ + "assets/img/组 225@2x.af5397c2.png";